import { buildFilter, normalizeSpecialsDisplayName } from '@iheartjane/menu';
import { Flex, useMobileMediaQuery } from '@iheartjane/reefer';
import { EventNames } from '@iheartjane/tracking';
import { useLocation } from 'react-router';

import { useSearchContext } from '@jane/search/hooks';
import { useMenu, useSpecials } from '@jane/shared-ecomm/providers';
import { Track } from '@jane/shared-ecomm/tracking';

import { useComposeMenuFilters } from '../../hooks/useComposeMenuFilters';
import { MenuSpecialsBanner } from '../../MenuComponents/MenuBanners/MenuSpecialsBanner/MenuSpecialsBanner';
import { MenuFiltersAndProductsGrid } from '../../MenuComponents/MenuFiltersAndProductsGrid/MenuFiltersAndProductsGrid';
import { MenuPageSeo } from '../../MenuComponents/MenuSeo/MenuPageSeo';
import { MenuTitle } from '../../MenuComponents/MenuTitle/MenuTitle';
import { MenuSpecialsGrid } from './MenuSpecialsGrid';

export const MenuSpecials = () => {
  const location = useLocation();
  const isMobile = useMobileMediaQuery({});
  const { paths, store } = useMenu();
  const { searchState } = useSearchContext();
  const { specialIds } = useSpecials();

  const pageTitle = normalizeSpecialsDisplayName(
    store.specials_row_configs?.custom_display_name
  );

  const specialsFilter = buildFilter('applicable_special_ids', specialIds);
  const staticFilters = useComposeMenuFilters([specialsFilter]);
  const isFilteringProducts =
    Object.values(searchState).filter(Boolean).length > 0;

  const nextBreadcrumbs = [
    {
      title: pageTitle,
      url: location.pathname,
    },
  ];

  return (
    <Flex flexDirection="column" gap={isMobile ? 24 : 48} height="100%">
      <MenuPageSeo path={paths.menuCategory('specials')} title={pageTitle} />
      <Track event={{ event: EventNames.ViewedSpecial, isGold: false }} />
      <MenuTitle title={pageTitle} px={isMobile ? 24 : 64} />
      <MenuSpecialsBanner />

      {!isFilteringProducts && <MenuSpecialsGrid />}
      <MenuFiltersAndProductsGrid
        breadcrumbs={nextBreadcrumbs}
        menuCategory="specials"
        pageTitle={pageTitle}
        staticFilters={staticFilters}
      />
    </Flex>
  );
};
